module.exports = __webpack_public_path__ + "img/unlimited-table.a4da442b.svg";